import axios from 'axios'
import qs from 'qs' // 传给后台的数据为form格式
import { Message } from 'element-ui'
import { get } from '../assets/js/cookie'
import self from '../main'
// Vue.use(Vlf)
// import router from '../router'
// 上传文件调取的接口(解决上传FormData数据浏览器不显示问题)
export function upLoadFile() {
  return axios.create({
    withCredentials: true, // 设置axios跨域
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// const baseUrl = require('../assets/js/global').baseUrl
// 创建axios实例
const service = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? `${window.location.origin}/api/pc/`
      : '/api',
  timeout: 15000, // 请求超时时间
  method: 'post',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }, // 请求头处理，设置传给后台的参数格式，有form和json格式，这样写是form格式，application/json是json格式
  retry: 4,
  retryDelay: 1000
})
function getUserData(url) {
  return new Promise((resolve, reject) => {
    self.$vlf.getItem('USER_DATA').then(function(value) {
      const isDongYang =
        process.env.NODE_ENV === 'production' &&
        window.location.hostname === 'dongyang.weixiaotong.com.cn'
      let params = { campusid: isDongYang ? '403526' : '3418' }
      if (value) {
        Object.assign(params, { userName: value.userName })
        if (url.includes('parentlicense')) {
          Object.assign(params, {
            campusid: isDongYang ? '403526' : '3904',
            userid: value.parentlicenseUserid
          })
        } else {
          Object.assign(params, {
            userid: value.userid
          })
        }
      }
      resolve(params)
    })
  })
}
// request 拦截器
service.interceptors.request.use(config => {
  let { url, data, method } = config

  return getUserData(url).then(res => {
    const params = Object.assign(res, data)
    if (method === 'post') {
      const readonly = true
      config.data =
        data instanceof Object
          ? qs.stringify({ apiparams: JSON.stringify({ params, readonly }) })
          : data
    }
    return config
  })
})

// respone拦截器
service.interceptors.response.use(
  response => {
    return get({
      key: 'JSSSID_COOKIE'
    })
      .catch(() => {
        self.$vlf.removeItem('USER_DATA')
        self.$eventBus.$emit('removeUserData')
      })
      .then(res => {
        if (response.data.ret.code !== '200') {
          Message.error(response.data.ret.msg)
          return Promise.reject(response.data.data)
        }
        return response.data.data
      })
  },
  error => {
    if (error.message) {
      // 登录超时
      if (error.message === 'Network Error') {
        // Dialog.alert({message:'登录超时'})
        // router.push('/home')
      }
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/index.js